import { getApps, initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"

const firebaseConfig = {
	apiKey: "AIzaSyC6gHNirETe74SsULnEA7Zhx2byh1ltqVE",
	authDomain: "auth.kopy.app",
	databaseURL: "https://kopy-8e77b.firebaseio.com",
	projectId: "kopy-8e77b",
	storageBucket: "kopy-8e77b.appspot.com",
	messagingSenderId: "364326054726",
	appId: "1:364326054726:web:ae095f3e9777e41d735347",
}

export const firebaseApp = !getApps().length
	? initializeApp(firebaseConfig)
	: getApps()[0]
const auth = getAuth(firebaseApp)

export { auth }
